import { call, delay, put, takeLatest } from "redux-saga/effects";

// requests

// actions
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { PackageTypeActionTypes, PackageTypeActions } from "../../../actionTypes/master/packageTypeActionTypes";
import {
  createPackageTypeApi,
  editPackageTypeDataByIdApi,
  getPackageTypeDataByIdApi,
  getPackageTypeListApi,
} from "../../requests/master/packageTypeRequests";
import { getPackageTypeList, setPackageTypeDataById, setPackageTypeList, setPackageTypeListPageCount } from "../../../actions/master/packageTypeAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createPackageTypeHandler(action: PackageTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createPackageTypeApi, action.payload);
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPackageTypeListHandler(action: PackageTypeActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPackageTypeListApi, action.payload);
    if (data.status) {
      yield put(setPackageTypeList(data?.data?.rows));
      yield put(setPackageTypeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPackageTypeDataByIdHandler(action: PackageTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPackageTypeDataByIdApi, action.payload);
    if (data.status) {
      yield put(setPackageTypeDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editPackageTypeDataByIdHandler(action: PackageTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editPackageTypeDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getPackageTypeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* packageTypeSaga() {
  yield takeLatest(PackageTypeActions.CREATE_PARCEL, createPackageTypeHandler);
  yield takeLatest(PackageTypeActions.GET_PARCEL_LIST, getPackageTypeListHandler);
  yield takeLatest(PackageTypeActions.GET_PARCEL_DATA_BY_ID, getPackageTypeDataByIdHandler);
  yield takeLatest(PackageTypeActions.EDIT_PARCEL_DATA_BY_ID, editPackageTypeDataByIdHandler);
}
